import { h, Fragment } from 'preact';

import { IconArrowLinkDown } from '../../../components/1-foundation/icons/icons';
import Hero from '../../../components/3-molecules/hero/hero';
import SectionDivider from '../../../components/3-molecules/section-divider/section-divider';
import SkyItFeatureList from '../../../components/3-molecules/sky-it-feature-list/sky-it-feature-list';
import SkyItFeatureListsWrapper from '../../../components/3-molecules/sky-it-feature-list/sky-it-feature-lists-wrapper';

const buildHeroImage = (data, isUserLogged) => ({
  alt: data.alt,
  sizeMobile: '55vw',
  sizeDesktop: '100vw',
  srcMobile: data.imageMobile,
  srcDesktop: data.imageDesktop,
  ratioModifier: isUserLogged ? 'hero-preferences-page-logged' : 'hero-preferences-page-not-logged',
});

export const renderHeroAndFeatureList = ({ data, handlers, isUserLogged }) => {
  const boxesOrdered = data.featureList?.boxes?.sort((a, b) => a.position - b.position);
  const featuresOrdered = data.featureList?.features?.sort((a, b) => a.position - b.position);
  const buildItemsForFeatureList = (boxId) =>
    featuresOrdered.map((item) => ({
      text: item.label,
      disabled: item.disabled?.[boxId],
    }));

  return (
    <Fragment>
      <Hero
        modifiers={['sky-it']}
        image={buildHeroImage(data, isUserLogged)}
        title={isUserLogged ? data.title : null}
        abstract={isUserLogged ? data.subtitle : null}
      />
      {!isUserLogged && <SectionDivider title={data.title} description={data.subtitle} modifiers={['sky-it']} />}
      {boxesOrdered && (
        <SkyItFeatureListsWrapper>
          {boxesOrdered.map((box, i) => (
            <SkyItFeatureList
              key={box.label}
              title={box.label}
              items={buildItemsForFeatureList(box.id)}
              cta={{
                text: box.ctaLabel,
                target: box.ctaTarget,
                href: i === 0 ? box.ctaUrl : null,
                modifiers: [i === 0 ? 'sky-it-primary' : 'sky-it-outline'],
                append: i === 0 ? null : <IconArrowLinkDown />,
                onClick: i === 0 ? null : handlers.handleFeatureListCtaClick,
              }}
            />
          ))}
        </SkyItFeatureListsWrapper>
      )}
    </Fragment>
  );
};
